/**
 *
 * @class ViewOrientation
 *
 * holder for the parameters of the user's orientation in a panorama;
 *
 *   h   - horizontal angle
 *   v   - vertical angle
 *   fov - field of view (basically zoom)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class ViewOrientation {

  /** the horizontal angle */
  public h: number = 0;

  /** the vertical angle */
  public v: number = 0;

  /** the zoom */
  public fov: number = 0;

  /** standard constructor */
  public constructor (init?: Partial<ViewOrientation>) {

    Object.assign(this, init);

  }
}
